<div class="">
    <!-- <div class="col-md-6" *ngFor="let item of group | keyvalue">
        <div class="accordion" [id]="'accordion'+item.key">
            <div class="card">
              <div class="card-header" [id]="'heading'+item.key">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-left btn-primary" type="button" data-toggle="collapse" [attr.data-target]="'#collapse'+item.key" aria-expanded="true" aria-controls="collapseOne">
                    <span [class]="getTabIcon(item.key)"></span> {{getTab(item.key)}}
                  </button>
                </h2>
              </div>
          
              <div [id]="'collapse'+item.key" class="collapse show" [attr.aria-labelledby]="'heading'+item.key" [attr.data-parent]="'#accordion'+item.key">
                <div class="card-body">
                    <ul>
                        <li *ngFor="let el of item.value">{{el.description}}</li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
    </div> -->
    <div *ngIf="rolesLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
      margin-bottom: 20%;">
    </div>
    <div class="row" *ngIf="!rolesLoading">
      <div class="col-12 col-lg-6">
        <div class="accordion row col-12" *ngFor="let item of tabs.slice(0, (tabs.length/2)+1); let i=index" [id]="'accordion'+item.toLowerCase()">
          <div class="card row col-12">
            <div class="card-header" [id]="'heading'+item.toLowerCase()">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left btn-primary" [ngClass]="{'collapsed': i!=0}"  type="button" data-toggle="collapse" [attr.data-target]="'#collapse'+item.toLowerCase()" [attr.aria-expanded]="i==0? true : false"  [attr.aria-controls]="'collapse'+item.toLowerCase()">
                  <span [class]="getTabIcon(item)"></span> {{getTab(item)}}
                </button>
              </h2>
            </div>
        
            <div [id]="'collapse'+item.toLowerCase()" class="collapse" [ngClass]="{'show': i==0}" [attr.aria-labelledby]="'heading'+item.toLowerCase()" [attr.data-parent]="'#accordion'+item.toLowerCase()">
              <div class="card-body">
                <h3 *ngIf="roles.length==0||group[item]?.length==0" style="font-size: 16px;"> - Aucun role dans {{getTab(item)}}</h3>
                <ul *ngIf="group[item]?.length>0">
                  <li *ngFor="let el of group[item]">{{el.description}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="accordion row col-12" *ngFor="let item of tabs.slice((tabs.length/2) + 1)" [id]="'accordion'+item.toLowerCase()">
          <div class="card row col-12">
            <div class="card-header" [id]="'heading'+item.toLowerCase()">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left btn-primary collapsed" type="button" data-toggle="collapse" [attr.data-target]="'#collapse'+item.toLowerCase()" aria-expanded="false" [attr.aria-controls]="'collapse'+item.toLowerCase()">
                  <span [class]="getTabIcon(item)"></span> {{getTab(item)}}
                </button>
              </h2>
            </div>
        
            <div [id]="'collapse'+item.toLowerCase()" class="collapse" [attr.aria-labelledby]="'heading'+item.toLowerCase()" [attr.data-parent]="'#accordion'+item.toLowerCase()">
              <div class="card-body">
                <h3 *ngIf="roles.length==0||group[item]?.length==0" style="font-size: 16px;"> - Aucun role dans {{getTab(item)}}</h3>
                  <ul *ngIf="group[item]?.length>0" >
                    <li *ngFor="let el of group[item]">{{el.description}}</li>
                  </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>